import React from "react";
import styled from "@emotion/styled";
import { SxProps, Theme, Typography, useTheme, Stack, TypographyProps } from "@mui/material";
import { PaginationButton } from "../../pagination-button";
import useAIDTMediaQuery from "../../../hooks/useAIDTMediaQuery";

const FooterContainer = styled(Stack)`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  flex-direction: row;
  gap: 0.75rem;
  font-size: 0.875rem;
`;

const FooterPagination = styled(Typography) <{ isTablet: boolean }>`
  padding: ${({ isTablet }) => (isTablet ? "0 0.625rem" : "0 2rem")};
  white-space: nowrap;
`;

const StyledCurrentPage = styled.span<{ fontColor: string }>`
  color: ${({ fontColor }) => fontColor};
`;

export interface LayoutFooterPagingProps {
  currentPage: number;
  totalPage: number;
  onPrev?: () => void;
  onNext?: () => void;
  allowPrev?: boolean;
  allowNext?: boolean;
  variant?: TypographyProps['variant'];
  currentPageColor?: string;
  textColor?: string;
}

const LayoutFooterPaging: React.FC<LayoutFooterPagingProps> = ({
  currentPage,
  totalPage,
  onPrev,
  onNext,
  allowPrev = true,
  allowNext = true,
  variant = "subtitle1",
  currentPageColor,
  textColor,
}) => {
  const theme = useTheme();
  const { isTablet } = useAIDTMediaQuery();

  return (
    <FooterContainer>
      {isTablet && <PaginationButton left onClick={onPrev} disabled={!allowPrev} size={24} />}
      <FooterPagination variant={variant} sx={{ color: textColor || "#D8D8E2" }} isTablet={isTablet}>
        <StyledCurrentPage fontColor={currentPageColor || theme.palette.primary.main}>
          <span>{currentPage}</span>
        </StyledCurrentPage>{" "}
        <span>/</span>{" "}
        <span>{totalPage}</span>
      </FooterPagination>
      {isTablet && <PaginationButton right onClick={onNext} disabled={!allowNext} size={24} />}
    </FooterContainer>
  );
};

export default LayoutFooterPaging;
